@let _instructionDTO = instructionDTO();
<nz-row [nzGutter]="[16, 16]">
  <nz-col [nzSpan]="24">
    <h2 class="instruction-title" nz-typography>
      {{ _instructionDTO.title }}
    </h2>
  </nz-col>
  <nz-col [nzSpan]="24">
    <nz-list
      [nzBordered]="false"
      [nzItemLayout]="'vertical'"
      [nzSize]="'large'">
      <nz-list-header>
        <span nz-typography
          ><strong>{{ _instructionDTO.header }}</strong></span
        >
      </nz-list-header>
      @for (
        instructionStepDTO of _instructionDTO.steps;
        track instructionStepDTO.title;
        let index = $index
      ) {
        <nz-list-item [nzNoFlex]="true">
          <nz-list-item-meta>
            <nz-list-item-meta-title>
              <span [ngClass]="['index', getIndexClass(index)]" nz-typography>{{
                instructionStepDTO.title
              }}</span>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
          <span nz-typography>{{ instructionStepDTO.description }}</span>
        </nz-list-item>
      }
      <nz-list-footer>
        <span nz-typography
          ><strong>{{ _instructionDTO.footer }}</strong></span
        >
      </nz-list-footer>
    </nz-list>
  </nz-col>
</nz-row>
